import {
    isSignInWithEmailLink,
    signInWithEmailLink,
  } from "firebase/auth";
import { useAuth } from "hooks/AuthContext";
import { useError } from "hooks/ErrorContext";
import { useSuccess } from "hooks/SuccessContext";
  import { auth } from "utils/firebase";

export const FinishSignInViaEmail = async () => {
  const { storeToken } = useAuth()
  const { showMessage } = useSuccess()
  const {showError} = useError()
    if (isSignInWithEmailLink(auth, window.location.href)) {
      let email = window.localStorage.getItem("emailForSignIn");
      if (!email) {
        email = window.prompt("Please provide your email for confirmation");
      }
      try {
        const result = await signInWithEmailLink(auth, email, window.location.href);
        window.localStorage.removeItem("emailForSignIn");
        const idToken = await result.user.getIdToken();
        storeToken(idToken)
        showMessage("Successfully logged in")

      } catch (error) {
        showError('Error occoured while Login')
        console.error("Error signing in with email link:", error);
      }
    }
  };
